import { GetStaticBody } from './../../../../models/data/user.model';
import { UiFunction,UiDepartment } from './../../../../models/data/UI-data.model ';
import { Action, createReducer, on } from '@ngrx/store';
import * as HomePageActions from '../actions/home-page.actions'

export const homePageFeatureKey = 'homePage';

export interface State {
  uiDepartment:UiDepartment[],
  selectedDepartment:number,
  selectedFunction:string,
  staticData:GetStaticBody
}

export const initialState: State = {
  uiDepartment:[],
  selectedDepartment:null,
  selectedFunction:null,
  staticData:null
};

export const reducer = createReducer(
  initialState,

  on(HomePageActions.clearUIHomePage,state =>initialState),

  on(HomePageActions.setUiDepartment,(state,action)=>{
    return {
      ...state,
      uiDepartment:action.uiDepartment
    }
  }),


  on(HomePageActions.clearUiDepartment,(state,action)=>{
    return {
      ...state,
      uiDepartment:initialState.uiDepartment
    }
  }),

  // on(HomePageActions.upsertUiFunction,(state,action)=>{
  //   const baseFunction = state.uiFunction.filter(uiFunction => uiFunction.functionCode !== action.UiFunction.functionCode)
  //   return {
  //     ...state,
  //     uiFunction:[...baseFunction,action.UiFunction].sort(compareByKeyInOrder('functionCode', UISortingOrder.ASCENDING))
  //   }
  // }),

  on(HomePageActions.setSelectedDepartment,(state,action)=>{
    return {
      ...state,
      selectedDepartment:action.selectedDepartment
    }
  }),

  on(HomePageActions.clearSelectedDepartment,(state)=>{
    return {
      ...state,
      selectedDepartment:initialState.selectedDepartment
    }
  }),

  on(HomePageActions.setSelectedFunction,(state,action)=>{
    return{
      ...state,
      selectedFunction:action.selectedFunction
    }
  }),

  on(HomePageActions.clearSelectedFunction,(state)=>{
    return {
      ...state,
      selectedFunction:initialState.selectedFunction
    }
  }),

  on(HomePageActions.setStaticData,(state,action)=>{
    return {
      ...state,
      staticData:action.staticData
    }
  }),

  on(HomePageActions.clearStaticData,(state)=>{
    return {
      ...state,
      staticData:initialState.staticData
    }
  }),

  on(HomePageActions.setStaticDataDefaultModules,(state,action)=>{
    return {
      ...state,
      staticData:{
        ...state.staticData,
        defaultModuleList:action.defaultModules
      }
    }
  })

  );
